import { makeStyles } from '@material-ui/styles'

export default makeStyles(theme => ({
    wrapper: {
        border: 0,
        background: 'transparent',
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        alignItems: 'center',
        padding: '8px 12px',

        '&:hover': {
            cursor: 'pointer',
            background: 'linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.06) 0%)',
        },
    },
    imgWrapper: {
        width: 142,
        height: 84,
        position: 'relative',

        '& .loaded, & .has-error': {
            objectFit: 'cover',
        },

        '&:hover .video-item-img, & .video-item-gif': {
            display: 'none',
        },

        '&:hover .video-item-gif': {
            display: 'block',
        },
    },
    blockedImg: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundColor: '#4a5775',
        opacity: 0.8,
        zIndex: theme.zIndexLevels.one,
        display: 'flex',
        color: 'white',
        justifyContent: 'center',
        alignItems: 'center',
    },
    infoWrapper: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        paddingLeft: 12,
        fontSize: 14,
        fontWeight: 'bold',
    },
    title: {
        color: theme.colors.white,
        letterSpacing: '-0.35px',
        marginBottom: 8,
    },
    blockedTitle: {
        color: '#b8bfca',
    },
    duration: {
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        letterSpacing: 'normal',
        color: '#b8bfca',
    },
}))
